import { useMutation } from '@tanstack/react-query';
import { advisorAdminApi } from '../api/api';

export function useDeleteAdvisorAccount() {
  const mutation = useMutation({
    mutationFn: (advisorId: string) => advisorAdminApi.deleteAdvisorAccount(advisorId),
  });

  return {
    deleteAccount: mutation.mutateAsync,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data ?? null,
    reset: mutation.reset,
  };
}
